import { DeclarationV2State, initialDeclarationV2State } from "../../App/DeclarationV2/types";

/**
 * Déclaration de cours v2 : un seul objet d'état, mis à jour par fusion
 * partielle et remis à zéro explicitement. Indépendant du reducer historique
 * `declarationCourse` (ancien parcours sur `/declare`).
 */
export const DECLARATION_V2_UPDATE = "DECLARATION_V2_UPDATE";
export const DECLARATION_V2_RESET = "DECLARATION_V2_RESET";

export const updateDeclarationV2 = (patch: Partial<DeclarationV2State>) => ({
    type: DECLARATION_V2_UPDATE,
    payload: patch,
});

export const resetDeclarationV2 = () => ({ type: DECLARATION_V2_RESET });

export function declarationV2Reducers(state: DeclarationV2State | null = null, action: any): DeclarationV2State | null {
    switch (action.type) {
        case DECLARATION_V2_UPDATE:
            return {
                ...(state ?? initialDeclarationV2State()),
                ...action.payload,
                updatedAt: new Date().toISOString(),
            };
        case DECLARATION_V2_RESET:
            return initialDeclarationV2State();
        default:
            return state;
    }
}
